module.exports = __webpack_public_path__ + "img/button_presnaZhoda_off.22a1e9bd.svg";